import { Component, OnInit, Inject } from '@angular/core';
import { PageComponent, ICC_PAGE_DATA } from '@icc/configurator/shared';
import { _ } from "@icc/shared/helpers";

@Component({
    selector: 'icc-montages-info-page',
    templateUrl: './montages-info-page.component.html',
    styleUrls: ['./montages-info-page.component.scss'],
    standalone: false
})
export class MontagesInfoPageComponent extends PageComponent implements OnInit {

  title = _('ROLLER_SHUTTER_LEGACY|Informacja o montażu');

  constructor(
    @Inject(ICC_PAGE_DATA) public pageData: {
      details: any
    }
  ) {
    super();
  }

  ngOnInit() {
  }

}
